export const getWithoutUndefined = (object) => {
    if (isEmpty(object)) {
        return {};
    }
    return Object.entries(object).reduce((map, [key, value]) => {
        if (typeof value === 'undefined') {
            return map;
        }
        return Object.assign(Object.assign({}, map), { [key]: value });
    }, {});
};
export const isObject = (object) => {
    return typeof object === 'object' && !Array.isArray(object);
};
export const isEmpty = (object, options) => {
    const { checkNestedKeys } = options || {};
    const checkByObjectKeys = (object) => {
        if (checkNestedKeys) {
            return !Object.keys(object).some((key) => !isEmpty(object[key]));
        }
        return !Object.keys(object).length;
    };
    return (typeof object === 'undefined' ||
        object === null ||
        (isObject(object) && checkByObjectKeys(object)));
};
